module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "co-area container"
  }, [_c('com-title', {
    attrs: {
      "title": "合作领域"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "columns is-mobile"
  }, _vm._l((_vm.areas), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "column is-one-third-mobile"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69197dcc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/training/consultation/co-area.vue
// module id = 457
// module chunks = 1